module.exports = __webpack_public_path__ + "static/media/clock.d169b441.svg";